import { Skeleton, Table } from '@exxonmobil/react-unity';
import React from 'react';
import { TableCell } from './TableComponents';

interface Props {
  columnSpan: number;
  rowNumber: number;
}

export const DataTableLoading = ({ columnSpan, rowNumber }: Props) => (
  <Table.Body data-testid="data-table-loading">
    {[...Array(rowNumber)].map((_, index) => (
      <Table.Body.Row key={index}>
        <TableCell colSpan={columnSpan}>
          <Skeleton />
        </TableCell>
      </Table.Body.Row>
    ))}
  </Table.Body>
);
